import { AfterViewInit, Component, OnInit } from '@angular/core';
import maplibregl, { Marker, Popup } from 'maplibre-gl';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { Subject, interval } from 'rxjs';
import { Observable, fromEvent } from 'rxjs';
import { catchError, distinctUntilChanged, map } from 'rxjs/operators';
import supercluster, { PointFeature } from 'supercluster';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
  selector: 'app-vw-tracking',
  templateUrl: './vw-tracking.component.html',
  styleUrls: ['./vw-tracking.component.css'],
  standalone: false
})
export class VwTrackingComponent implements OnInit {
  apiKey = "v1.public.eyJqdGkiOiI5YWE5M2IzZC04YzJiLTRmN2EtOTdiZi1lM2U4Y2VjZDdlNmMifY-CsFf09lpFoqmfVP5RNrfgBujnc_10Dj3L6UNokoG7iIfIc-atKXyTtGjsvFjyTvTZucDqshFuaQwjiqpJcYurZiZSljynClRnFynKcqOayP-7aq8syTBj7xHbbRkRq5DbWrLpXdYQK6-E_OBdEGDE89wT7S6pFHUSOdWzuBcXrTeA7OemFI5SIoD5JuLzHZzLsWcTmfvfzNCWMvS2VN57fpAu5yWLEilBpc3CYB1oiQmsLix8ugGlxSWx6RdoV6ZpyfqwgB0NbUKT2GJUKK8RB8s1pebBZF_0n7_rwMkGqmxgXgZT1g7xXsWI5O__wf9HjAxCsi05r5-JeyZTDqQ.ZTA0NDFlODYtNGY5Mi00NWU4LTk1MDgtMmY4YmViYWFhYjUz";
  mapName = "e-transportMap";
  region = "sa-east-1";
  markerImagePath!: string;
  // markerImagePath: string = 'assets/truck.png';
  // markerImagePathVerde: string = 'assets/truckVerde.png';
  posicao!: any[];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaTripsFiltro: string = 'https://q1ktorqcr3.execute-api.sa-east-1.amazonaws.com/V1/';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaComFiltroNovo: string = 'https://se468a0eif.execute-api.sa-east-1.amazonaws.com/v1';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  query: string = 'Operacao_Interplantas_Karrara';
  query2: string = 'positionLOTS';
  query3: string = 'Itens_Jetta';
  query4: string = 'Porta_Rastreando_VW';
  query5: string = 'items_Excel_Karrara';
  queryFornecedores: string = 'Fornecedores_Karrara_Transport';
  planilhaJSL: string = 'PlanilhaVWJSL';
  planilhaJSLItaqua: string = 'PlanilhaVWJSLItaqua';
  planilhaTCM: string = 'PlanilhaVWTCM';
  planilhaTCMSBC: string = 'PlanilhaVWTCMSBC';
  planilhaSESE: string = 'PlanilhaVWSESE';
  placaFiltrada!: string;
  posicaoSul!: any[];
  posicaoVeiculos!: any[];
  filtro: boolean = false;
  subscription: any;
  private placaFiltradaSubject = new Subject<string>();
  posicaoLOTS!: any[];
  posicaoArg!: any[];
  posicaoArgRastreio!: any[];
  isLoading: boolean = true;
  usuarioLogado: any;
  maiorHorarioJanela!: number;
  carros!: any[];
  markers!: maplibregl.Marker[];
  map: any;
  cluster!: supercluster<supercluster.AnyProps, supercluster.AnyProps>;
  index: number = 0;
  filterColumn: string = 'date';
  referenceDate!: string;
  numDays: number = 5;
  queryContainers: string = 'items_Excel_Container';
  containers!: any[];
  carrosVerdes: number = 0;
  carrosVermelhos: number = 0;
  verVerdes: boolean = true;
  verVermelhos: boolean = true;
  verSUZAN: boolean = false;
  verLOTS: boolean = false;
  verSemSinal: boolean = true;
  verComSinal: boolean = true;
  verJSLARG: boolean = false;
  verJSL: boolean = true;
  verTCM: boolean = true;
  verJSLItaqua: boolean = true;
  verTCMSBC: boolean = true;
  verSESE: boolean = false;
  verLocais: boolean = false;
  itemEditado: any;
  dialogOpen: boolean = false;
  item: any;
  edit2: boolean = false;
  fornecedores!: any[];
  marcadores: any[] = [];
  verNomeLocais: boolean = true;
  locais!: any[];
  carrosComSinal: number = 0;
  containersEXP!: any[];
  DataAtual!: Date;
  carrosSemSinal: number = 0;
  markerImageSinal!: string;
  posicaoJSL!: any[];
  posicaoJSLItaqua!: any[];
  posicaoTCM!: any[];
  posicaoTCMSBC!: any[];
  posicaoSESE!: any[];
  pontoFiltro!: string;

  constructor(
    private dynamodbService: ApiService,
    private servicoAutenticacao: AutenticacaoService,
  ) {
    this.placaFiltrada = '';
  }


  markerCoordinates: [number, number][] = [];

  async ngOnInit(): Promise<void> {
    await this.getUserLogado();
    await this.getFornecedoresFromDynamoDB();
    this.markers = [];
    this.map = new maplibregl.Map({
      container: "map",
      style: `https://maps.geo.${this.region}.amazonaws.com/maps/v0/maps/${this.mapName}/style-descriptor?key=${this.apiKey}`,
      center: [-45.73253253553887, -22.30833544028489],
      zoom: 6,
      transformRequest: (url, resourceType) => {
        if (url.startsWith("https://api.mapbox.com")) {
          // Adicione a chave de acesso como parâmetro na URL da requisição
          url += "&access_token=" + this.apiKey;
        }
        return { url };
      }
    });
    this.cluster = new supercluster({
      radius: 40, // O raio de agrupamento (em pixels)
      maxZoom: 10, // O zoom máximo em que os agrupamentos serão ativados
    });
    await this.update();
    // this.containers = this.containers.concat(this.containersEXP);
    await this.inicia();
    this.isLoading = false;

    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.update();
      await this.inicia();
    });
  }

  async update() {
    await this.getLocais();
    this.posicaoJSL = await this.getPosicaoFromDynamoDB(this.planilhaJSL);
    this.posicaoJSLItaqua = await this.getPosicaoFromDynamoDB(this.planilhaJSLItaqua);
    this.posicaoTCM = await this.getPosicaoFromDynamoDB(this.planilhaTCM);
    this.posicaoTCMSBC = await this.getPosicaoFromDynamoDB(this.planilhaTCMSBC);
    this.posicaoSESE = await this.getPosicaoFromDynamoDB(this.planilhaSESE);
    await this.getPosicaoMilkRastreioFromDynamoDB();
    await this.compareAndMergePlatesJSL();
    await this.compareAndMergePlatesJSLItaqua();
    await this.compareAndMergePlatesTCM();
    await this.compareAndMergePlatesTCMSBC();
    await this.compareAndMergePlatesSESE();
    console.log(this.posicaoJSL)
    console.log(this.posicaoJSLItaqua)
    console.log(this.posicaoTCM)
    console.log(this.posicaoSESE)
    // await this.inicia();
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
  }

  async atualizarMarcadores(): Promise<void> {
    this.markerCoordinates = [];
    this.carrosVerdes = 0;
    this.carrosVermelhos = 0;
    this.carrosComSinal = 0;
    this.carrosSemSinal = 0;
    // console.log(this.posicaoArg)
    // console.log("atualizou marcadores")
    this.markerCoordinates = await this.posicaoJSL
      .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      .map((item: any) => ({
        // Outros campos do objeto que você deseja manter
        Longitude: item.Longitude.toString(),
        Latitude: item.Latitude.toString()
      }))
      .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      .concat(
        this.posicaoJSLItaqua
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )
      .concat(
        this.posicaoTCM
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )
      .concat(
        this.posicaoTCMSBC
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )
      .concat(
        this.posicaoSESE
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
          .map((item: any) => [item?.Longitude, item?.Latitude] as [number, number])
      )

  }

  async atualizarCarros(): Promise<void> {
    this.carros = [];
    this.carrosVerdes = 0;
    this.carrosVermelhos = 0;
    console.log("atualizou carros")
    // console.log(this.posicao)
    // console.log(this.posicaoLOTS[0])
    // console.log(this.posicaoSul)
    // console.log(this.posicaoArg)
    this.carros = this.posicaoJSL
      .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      .concat(
        this.posicaoJSLItaqua
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      ).concat(
        this.posicaoTCM
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      ).concat(
        this.posicaoTCMSBC
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      ).concat(
        this.posicaoSESE
          .filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != "")
      )
    // console.log(this.carros.length)
  }

  async handleChange() {
    // Esta função será chamada sempre que o estado do checkbox mudar
    // console.log('O status do checkbox mudou.');
    await this.inicia();
  }

  removeAllMarkers(): void {
    // console.log("entrou remove")
    // console.log(this.marcadores)
    this.marcadores.forEach(marker => marker.remove());
    this.marcadores = [];
  }

  async inicia(): Promise<void> {
    // console.log(this.posicao)
    // console.log(this.posicao.filter((item: any) => item?.Longitude != undefined && item?.Latitude != undefined && item?.Latitude != null && item?.Latitude != 'None' && item?.Latitude != ""))
    await this.atualizarMarcadores();
    await this.atualizarCarros();

    const adicionarMarcadoresImportantes = (locais: any[]) => {
      this.removeAllMarkers();
      locais.forEach(local => {
        // console.log(local)
        const { latitude, longitude, popupContent } = local;
        // Converta as coordenadas para números
        const lat = parseFloat(latitude);
        const lng = parseFloat(longitude);
        try {
          // Verifique se as coordenadas estão dentro dos intervalos válidos
          if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
            // console.log(local)
            // console.log(lat)
            // console.log(lng)
            console.warn(`Coordenadas inválidas para o local: ${local}`);
            return; // Pule este local se as coordenadas forem inválidas
          }
          // Crie o marcador
          const marker = new maplibregl.Marker()
            .setLngLat([longitude, latitude]) // Use as coordenadas corretamente como uma tupla [longitude, latitude]
            .addTo(this.map);
          // Adicione um popup associado ao marcador (opcional)
          if (popupContent) {
            const popup = new maplibregl.Popup({ closeOnClick: false }).setText(popupContent);
            marker.setPopup(popup);
            // Abra o popup imediatamente
            // if(this.verNomeLocais){
            // popup.setLngLat([lng, lat]).addTo(this.map);
            // }
          }
          // Adicione o marcador ao array de marcadores
          this.marcadores.push(marker);
        } catch {
          console.log(local)
          console.log('lat: ', lat)
          console.log('lng: ', lng)
        }
      });
    };

    if (this.verLocais) {
      await adicionarMarcadoresImportantes(this.fornecedores);
    } else {
      await this.removeAllMarkers();
    }

    const atualizarMarcadores = async () => {
      await this.markers.forEach(async marker => {
        await marker.remove();
      });
      this.markers.length = 0;
      this.index = 0;
      await this.markerCoordinates.forEach(async (coordinates, index) => {
        let placa = '';
        placa = this.getPosicaoPlaca(coordinates); // Obtenha a placa com base nas coordenadas

        if (this.placaFiltrada !== '' && this.placaFiltrada !== null && this.placaFiltrada !== undefined) {
          const placaLowerCase = placa.toLowerCase();
          const filtroLowerCase = this.placaFiltrada.toLowerCase();
          if (!placaLowerCase.includes(filtroLowerCase)) {
          }
        }

        if (this.carros[index]['DataBordo'] === undefined) {
          this.carros[index]['Conexao'] = false;
        } else {
          this.DataAtual = new Date();
          var outraData = new Date(this.carros[index]['DataBordo']);
          if (new Date(outraData.setHours(outraData.getHours() + 1)) > this.DataAtual) {
            this.carros[index]['Conexao'] = true;
          } else {
            this.carros[index]['Conexao'] = false;
          }
        }

        this.carros[index].Fornecedores = this.carros[index].Fornecedores ? this.carros[index].Fornecedores : [
          this.carros[index]['Fornecedor 1'],
          this.carros[index]['Fornecedor 2'],
          this.carros[index]['Fornecedor 3'],
          this.carros[index]['Fornecedor 4']
        ].filter(f => !!f && f.trim() !== '').join(', ')

        if (this.carros[index].description && this.carros[index].description.includes('JSL Itaqua') && !this.verJSLItaqua) return; // Pula para a próxima iteração do loop
        if (this.carros[index].description && this.carros[index].description.includes('JSL') && !this.verJSL) return; // Pula para a próxima iteração do loop
        if (this.carros[index].description && this.carros[index].description.includes('TCM') && !this.verTCM) return; // Pula para a próxima iteração do loop
        if (this.carros[index].description && this.carros[index].description.includes('TCM SBC') && !this.verTCMSBC) return; // Pula para a próxima iteração do loop
        if (this.carros[index].description && this.carros[index].description.includes('SESE') && !this.verSESE) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Conexao && this.carros[index].Conexao == true && !this.verComSinal) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Conexao != true && !this.verSemSinal) return; // Pula para a próxima iteração do loop
        if (this.carros[index].Transportadora && this.carros[index].Transportadora == "SESE" && !this.verSESE) return; // Pula para a próxima iteração do loop
        if (this.placaFiltrada && this.carros[index].Plate && !this.carros[index].Plate.toUpperCase().includes(this.placaFiltrada.toUpperCase())) return; // Pula para a próxima iteração do loop
        if (this.pontoFiltro && this.carros[index].Fornecedores && !this.carros[index].Fornecedores.toUpperCase().includes(this.pontoFiltro.toUpperCase())) return; // Pula para a próxima iteração do loop

        const horaAtual = new Date().getTime();
        let maiorHorarioItem = 0;
        this.maiorHorarioJanela = 0;

        try {
          let horarioJanela = this.carros[index]['Janela'] && this.carros[index]['PassoEntrega'] != 1 && this.carros[index]['PassoEntrega'] != 2 ? this.carros[index]['Janela'] : "9900-01-01T00:00:00.000Z";
          horarioJanela = horarioJanela.replace("Z", "");
          const dataHorarioJanela = new Date(horarioJanela)
          const dataFormatadaHorarioJanela = dataHorarioJanela.getTime();

          let horarioJanela1 = this.carros[index]['Janela 1'] && this.carros[index]['Passo Fornecedor1'] != 1 && this.carros[index]['Passo Fornecedor1'] != 2 ? this.carros[index]['Janela 1'] : "9900-01-01T00:00:00.000Z";
          horarioJanela1 = horarioJanela1.replace("Z", "");
          const dataHorarioJanela1 = new Date(horarioJanela1);
          const dataFormatadaHorarioJanela1 = dataHorarioJanela1.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanela2 = this.carros[index]['Janela 2'] && this.carros[index]['Passo Fornecedor2'] != 1 && this.carros[index]['Passo Fornecedor2'] != 2 ? this.carros[index]['Janela 2'] : "9900-01-01T00:00:00.000Z";
          horarioJanela2 = horarioJanela2.replace("Z", "");
          const dataHorarioJanela2 = new Date(horarioJanela2);
          const dataFormatadaHorarioJanela2 = dataHorarioJanela2.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanela3 = this.carros[index]['Janela 3'] && this.carros[index]['Passo Fornecedor3'] != 1 && this.carros[index]['Passo Fornecedor3'] != 2 ? this.carros[index]['Janela 3'] : "9900-01-01T00:00:00.000Z";
          horarioJanela3 = horarioJanela3.replace("Z", "");
          const dataHorarioJanela3 = new Date(horarioJanela3);
          const dataFormatadaHorarioJanela3 = dataHorarioJanela3.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanela4 = this.carros[index]['Janela 4'] && this.carros[index]['Passo Fornecedor4'] != 1 && this.carros[index]['Passo Fornecedor4'] != 2 ? this.carros[index]['Janela 4'] : "9900-01-01T00:00:00.000Z";
          horarioJanela4 = horarioJanela4.replace("Z", "");
          const dataHorarioJanela4 = new Date(horarioJanela4);
          const dataFormatadaHorarioJanela4 = dataHorarioJanela4.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino1 = this.carros[index]['JanelaDestino 1'] && (!this.carros[index]['Passo Destino1'] || this.carros[index]['Passo Destino1'] < 1) ? this.carros[index]['JanelaDestino 1'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino1 = horarioJanelaDestino1.replace("Z", "");
          const datahorarioJanelaDestino1 = new Date(horarioJanelaDestino1);
          const dataFormatadahorarioJanelaDestino1 = datahorarioJanelaDestino1.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino2 = this.carros[index]['JanelaDestino 2'] && this.carros[index]['Passo Destino2'] != 1 && this.carros[index]['Passo Destino2'] != 2 ? this.carros[index]['JanelaDestino 2'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino2 = horarioJanelaDestino2.replace("Z", "");
          const datahorarioJanelaDestino2 = new Date(horarioJanelaDestino2);
          const dataFormatadahorarioJanelaDestino2 = datahorarioJanelaDestino2.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino3 = this.carros[index]['JanelaDestino 3'] && this.carros[index]['Passo Destino3'] != 1 && this.carros[index]['Passo Destino3'] != 2 ? this.carros[index]['JanelaDestino 3'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino3 = horarioJanelaDestino3.replace("Z", "");
          const datahorarioJanelaDestino3 = new Date(horarioJanelaDestino3);
          const dataFormatadahorarioJanelaDestino3 = datahorarioJanelaDestino3.getTime(); // Você pode ajustar o formato conforme necessário

          let horarioJanelaDestino4 = this.carros[index]['JanelaDestino 4'] && this.carros[index]['Passo Destino4'] != 1 && this.carros[index]['Passo Destino4'] != 2 ? this.carros[index]['JanelaDestino 4'] : "9900-01-01T00:00:00.000Z";
          horarioJanelaDestino4 = horarioJanelaDestino4.replace("Z", "");
          const datahorarioJanelaDestino4 = new Date(horarioJanelaDestino4);
          const dataFormatadahorarioJanelaDestino4 = datahorarioJanelaDestino4.getTime(); // Você pode ajustar o formato conforme necessário

          maiorHorarioItem = Math.min(dataFormatadaHorarioJanela, dataFormatadaHorarioJanela1, dataFormatadaHorarioJanela2, dataFormatadaHorarioJanela3, dataFormatadaHorarioJanela4,
            dataFormatadahorarioJanelaDestino1, dataFormatadahorarioJanelaDestino2, dataFormatadahorarioJanelaDestino3, dataFormatadahorarioJanelaDestino4);

          await this.someMethod(index);
          await this.findLocationNextPoint(this.carros[index], this.locais);

          if (maiorHorarioItem >= horaAtual) {
            // console.log("verde")
            try {
              if (!this.carros[index].nextPointCompleto.descarga) {
                this.markerImagePath = 'assets/truckVerdeIndo.png';
              } else {
                this.markerImagePath = 'assets/truckVerdeNewVoltando.png';
              }
            } catch {
              this.markerImagePath = 'assets/truckVerdeIndo.png';
            }
            this.carros[index].cor = 'verde';
            // console.log(this.carros[index])
            this.carrosVerdes += 1;
          } else {
            //console.log("vermelho")
            try {
              if (!this.carros[index].nextPointCompleto.descarga) {
                this.markerImagePath = 'assets/truckVermelhoNewIndo.png';
              } else {
                this.markerImagePath = 'assets/truckVermelhoNewVoltando.png';
              }
            } catch {
              this.markerImagePath = 'assets/truckVermelhoNewIndo.png';
            }
            this.carros[index].cor = 'vermelho';
            this.carrosVermelhos += 1;
          }
          // console.log(this.markerImagePath)

          if (this.carros[index].Conexao) {
            // console.log(this.carros[index].Conexao)
            this.markerImageSinal = 'assets/sinal.png';
            this.carrosComSinal += 1;
            // console.log(this.carrosComSinal)
          } else {
            this.markerImageSinal = 'assets/semSinal.png';
            this.carrosSemSinal += 1;
            // console.log(this.carros[index])
          }
          // console.log(this.markerImagePath)
        } catch {
          // console.log(index)
        }


        //   if (maiorHorarioItem > horaAtual) {
        //     this.markerImagePath = 'assets/truckVerdeIndo.png';
        //     this.carros[index].cor = 'verde';
        //     this.carrosVerdes++;
        //   } else {
        //     this.markerImagePath = 'assets/truckVermelhoNewIndo.png';
        //     this.carros[index].cor = 'vermelho';
        //     this.carrosVermelhos++;
        //   }
        //   if (this.carros[index].Conexao) {
        //     this.markerImageSinal = 'assets/sinal.png';
        //     this.carrosComSinal++;
        //   } else {
        //     this.markerImageSinal = 'assets/semSinal.png';
        //     this.carrosSemSinal++;
        //   }
        // } catch {
        //   console.log('************************************************************')
        //   console.log(index)
        //   console.log(this.carros[index])
        //   console.log(this.carros[index]['Janela'])
        //   console.log(this.carros[index]['PassoEntrega'])
        //   console.log(this.carros[index]['Janela 1'])
        //   console.log(this.carros[index]['Passo Fornecedor1'])
        //   console.log(this.carros[index]['Janela 2'])
        //   console.log(this.carros[index]['Passo Fornecedor2'])
        //   console.log(this.carros[index]['Janela 3'])
        //   console.log(this.carros[index]['Passo Fornecedor3'])
        //   console.log(this.carros[index]['Janela 4'])
        //   console.log(this.carros[index]['Passo Fornecedor4'])
        //   console.log(this.carros[index]['JanelaDestino 1'])
        //   console.log(this.carros[index]['Passo Destino1'])
        //   console.log(this.carros[index]['JanelaDestino 2'])
        //   console.log(this.carros[index]['Passo Destino2'])
        //   console.log(this.carros[index]['JanelaDestino 3'])
        //   console.log(this.carros[index]['Passo Destino3'])
        //   console.log(this.carros[index]['JanelaDestino 4'])
        //   console.log(this.carros[index]['Passo Destino4'])
        //   console.log(maiorHorarioItem)
        //   console.log(maiorHorarioItem > horaAtual)
        //   console.log(this.carros[index].nextPointCompleto.descarga)
        //   console.log('************************************************************')
        // }
        try {
          if (this.carros[index].cor == 'verde' && !this.verVerdes) return; // Pula para a próxima iteração do loop
          if (this.carros[index].cor == 'vermelho' && !this.verVermelhos) return; // Pula para a próxima iteração do loop
        } catch {
          // console.log(this.carros[index])
        }

        let marker = new maplibregl.Marker({ element: this.createMarkerElement(this.markerImagePath, this.markerImageSinal) })
          .setLngLat(coordinates)
          .addTo(this.map)

        let endereco = '';
        let fornecedor = '';
        endereco = this.getPosicaoEndereco(coordinates); // Obtenha o endereço com base nas coordenadas
        fornecedor = this.getPosicaoFornecedores(coordinates); // Obtenha o fornecedor com base nas coordenadas

        // this.carros[index].nextPoint = this.encontrarNextPoint(this.carros[index]);

        const popup = new maplibregl.Popup({ closeButton: true, closeOnClick: true })
          .setLngLat(coordinates)
          .setHTML(`<span style="font-weight: bold; font-size: 1.1em">Placa: ${placa}</span>
            <br>Fornecedores: ${fornecedor ? fornecedor : this.carros[index].idContainer ? this.carros[index].idContainer : this.carros[index].viagem ? "viagem " + this.carros[index].viagem :
              'Fornecedor não disponível'}
            <br>Peso: ${this.carros[index]?.['Weight Loaded'] ? this.carros[index]?.['Weight Loaded'] : 'Peso não disponível'}
            <br>Cubagem: ${this.carros[index]?.['Cubage'] ? this.carros[index]?.['Cubage'] : 'Cubagem não disponível'}
            <br>Volumes: ${this.carros[index]?.['Volumes'] ? this.carros[index]?.['Volumes'] : 'Volumes não disponível'}
            <br>Distancia: ${this.carros[index]?.['Total Distance'] ? this.carros[index]?.['Total Distance'] : 'Distancia não disponível'}
            <br>Endereço Atual: ${endereco ? endereco : this.carros[index]?.Endereco}`);

        marker.getElement().addEventListener('mouseover', () => {
          popup.addTo(this.map);
        });

        marker.getElement().addEventListener('click', () => {
          // console.log(this.carros[index])
          this.localizaCarroEdit(placa)
        });

        marker.getElement().addEventListener('mouseout', () => {
          popup.remove();
        });

        this.markers.push(marker);
        this.index++;
      });

      const pointFeatures: PointFeature<any>[] = this.markers.map(marker => {
        const [longitude, latitude] = marker.getLngLat().toArray();
        return {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Point',
            coordinates: [longitude, latitude],
          },
        };
      });

      this.cluster.load(pointFeatures);
    };

    const ocultarMarcadores = () => {
      this.markers.forEach(marker => {
        const placa = this.getPosicaoPlaca(marker.getLngLat().toArray()); // Obtenha a placa do marcador

        if (this.placaFiltrada !== '' && this.placaFiltrada !== null && this.placaFiltrada !== undefined) {
          if (placa !== this.placaFiltrada) {
            marker.getElement().style.display = 'none'; // Oculta o marcador
          } else {
            marker.getElement().style.display = ''; // Exibe o marcador
          }
        }
      });
    };

    await atualizarMarcadores();

    // Chamar a função ocultarMarcadores() sempre que o filtro for alterado
    const inputFiltro = document.getElementById('input-filtro');
    if (inputFiltro) {
      inputFiltro.addEventListener('input', ocultarMarcadores);
    }
  }

  async someMethod(index: number) {
    const nextPoint = await this.encontrarNextPoint(this.carros[index]);
    this.carros[index].nextPoint = nextPoint;
    // console.log(this.carros[index].nextPoint);
  }

  async atualizarPlacaFiltrada(event: Event) {
    const target = event.target as HTMLInputElement;
    const novoValor = target.value;
    if (this.placaFiltrada !== '' && this.placaFiltrada !== null && this.placaFiltrada !== undefined) {
      const placaLowerCase = novoValor.toLowerCase();
      const filtroLowerCase = this.placaFiltrada.toLowerCase();
      if (placaLowerCase.indexOf(filtroLowerCase) == -1) {
        return;
      }
    }
    this.placaFiltrada = novoValor;
    await this.inicia();
  }

  async procuraPontoParada(event: Event) {
    const target = event.target as HTMLInputElement;
    const novoValor = target.value;
    if (this.pontoFiltro !== '' && this.pontoFiltro !== null && this.pontoFiltro !== undefined) {
      const placaLowerCase = novoValor.toLowerCase();
      const filtroLowerCase = this.pontoFiltro.toLowerCase();
      if (placaLowerCase.indexOf(filtroLowerCase) == -1) {
        return;
      }
    }
    this.pontoFiltro = novoValor;
    await this.inicia();
  }

  private getPosicaoEndereco(coordinates: [number, number]): string {
    const posicaoJSL = this.posicaoJSL.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    const posicaoJSLItaqua = this.posicaoJSLItaqua.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    const posicaoTCM = this.posicaoTCM.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    const posicaoTCMSBC = this.posicaoTCMSBC.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    const posicaoSESE = this.posicaoSESE.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);


    let plate = "";
    if (posicaoJSL && posicaoJSL.Endereco) {
      plate += posicaoJSL.Endereco;
    }
    if (posicaoJSLItaqua && posicaoJSLItaqua.Endereco) {
      plate += posicaoJSLItaqua.Endereco;
    }
    if (posicaoTCM && posicaoTCM.Endereco) {
      plate += posicaoTCM.Endereco;
    }
    if (posicaoTCMSBC && posicaoTCMSBC.Endereco) {
      plate += posicaoTCMSBC.Endereco;
    }
    if (posicaoSESE && posicaoSESE.Endereco) {
      plate += posicaoSESE.Endereco;
    }



    return plate;
  }


  private getPosicaoPlaca(coordinates: [number, number]): string {
    let posicaoJSL = null;
    let posicaoJSLItaqua = null;
    let posicaoTCM = null;
    let posicaoTCMSBC = null;
    let posicaoSESE = null;
    posicaoJSL = this.posicaoJSL.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoJSLItaqua = this.posicaoJSLItaqua.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoTCM = this.posicaoTCM.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoTCMSBC = this.posicaoTCMSBC.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    posicaoSESE = this.posicaoSESE.find(item => item.Longitude == coordinates[0] && item.Latitude == coordinates[1]);
    // console.log(this.containers)
    // console.log(posicaoContainer)

    let plate = "";

    if (posicaoJSL && posicaoJSL.Plate) {
      plate += posicaoJSL.Plate;
      // console.log(plate)
    }

    if (posicaoJSLItaqua && posicaoJSLItaqua.Plate) {
      plate += posicaoJSLItaqua.Plate;
      // console.log(plate)
    }

    if (posicaoTCM && posicaoTCM.Plate) {
      plate += posicaoTCM.Plate;
      // console.log(plate)
    }

    if (posicaoTCMSBC && posicaoTCMSBC.Plate) {
      plate += posicaoTCMSBC.Plate;
      // console.log(plate)
    }
    if (posicaoSESE && posicaoSESE.Plate) {
      plate += posicaoSESE.Plate;
      // console.log(plate)
    }

    return plate;
  }

  private getPosicaoFornecedores(coordinates: [number, number]): string {
    const posicaoJSL = this.posicaoJSL.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoJSLItaqua = this.posicaoJSLItaqua.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoTCM = this.posicaoTCM.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoTCMSBC = this.posicaoTCMSBC.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);
    const posicaoSESE = this.posicaoSESE.find(item => item.Longitude === coordinates[0] && item.Latitude === coordinates[1]);

    let fornecedor = "";

    if (posicaoJSL) {
      // fornecedor += (" - " + posicaoJSL['Fornecedor 1']);
      fornecedor = [
        posicaoJSL['Fornecedor 1'],
        posicaoJSL['Fornecedor 2'],
        posicaoJSL['Fornecedor 3'],
        posicaoJSL['Fornecedor 4']
      ].filter(f => !!f && f.trim() !== '').join(', ')
    }
    if (posicaoJSLItaqua) {
      // fornecedor += (" - " + posicaoJSLItaqua['Fornecedor 1']);
      fornecedor = [
        posicaoJSLItaqua['Fornecedor 1'],
        posicaoJSLItaqua['Fornecedor 2'],
        posicaoJSLItaqua['Fornecedor 3'],
        posicaoJSLItaqua['Fornecedor 4']
      ].filter(f => !!f && f.trim() !== '').join(', ')
    }
    if (posicaoTCM) {
      // fornecedor += (" - " + posicaoTCM['Fornecedor 1']);
      fornecedor = [
        posicaoTCM['Fornecedor 1'],
        posicaoTCM['Fornecedor 2'],
        posicaoTCM['Fornecedor 3'],
        posicaoTCM['Fornecedor 4']
      ].filter(f => !!f && f.trim() !== '').join(', ')
    }
    if (posicaoTCMSBC) {
      // fornecedor += (" - " + posicaoTCMSBC['Fornecedor 1']);
      fornecedor = [
        posicaoTCMSBC['Fornecedor 1'],
        posicaoTCMSBC['Fornecedor 2'],
        posicaoTCMSBC['Fornecedor 3'],
        posicaoTCMSBC['Fornecedor 4']
      ].filter(f => !!f && f.trim() !== '').join(', ')
    }
    if (posicaoSESE) {
      // fornecedor += (" - " + posicaoSESE['Fornecedor 1']);
      fornecedor = [
        posicaoSESE['Fornecedor 1'],
        posicaoSESE['Fornecedor 2'],
        posicaoSESE['Fornecedor 3'],
        posicaoSESE['Fornecedor 4']
      ].filter(f => !!f && f.trim() !== '').join(', ')
    }
    // if (posicaoJSLItaqua && posicaoJSLItaqua['Fornecedor 1']) {
    //   fornecedor += (" - " + posicaoJSLItaqua['Fornecedor 1']);
    // }
    // if (posicaoJSLItaqua && posicaoJSLItaqua['Fornecedor 2']) {
    //   fornecedor += (" - " + posicaoJSLItaqua['Fornecedor 2']);
    // }
    // if (posicaoJSLItaqua && posicaoJSLItaqua['Fornecedor 3']) {
    //   fornecedor += (" - " + posicaoJSLItaqua['Fornecedor 3']);
    // }
    // if (posicaoJSLItaqua && posicaoJSLItaqua['Fornecedor 4']) {
    //   fornecedor += (" - " + posicaoJSLItaqua['Fornecedor 4']);
    // }
    // if (posicaoTCM && posicaoTCM['Fornecedor 1']) {
    //   fornecedor += (" - " + posicaoTCM['Fornecedor 1']);
    // }
    // if (posicaoTCM && posicaoTCM['Fornecedor 2']) {
    //   fornecedor += (" - " + posicaoTCM['Fornecedor 2']);
    // }
    // if (posicaoTCM && posicaoTCM['Fornecedor 3']) {
    //   fornecedor += (" - " + posicaoTCM['Fornecedor 3']);
    // }
    // if (posicaoTCM && posicaoTCM['Fornecedor 4']) {
    //   fornecedor += (" - " + posicaoTCM['Fornecedor 4']);
    // }
    // if (posicaoTCMSBC && posicaoTCMSBC['Fornecedor 1']) {
    //   fornecedor += (" - " + posicaoTCMSBC['Fornecedor 1']);
    // }
    // if (posicaoTCMSBC && posicaoTCMSBC['Fornecedor 2']) {
    //   fornecedor += (" - " + posicaoTCMSBC['Fornecedor 2']);
    // }
    // if (posicaoTCMSBC && posicaoTCMSBC['Fornecedor 3']) {
    //   fornecedor += (" - " + posicaoTCMSBC['Fornecedor 3']);
    // }
    // if (posicaoTCMSBC && posicaoTCMSBC['Fornecedor 4']) {
    //   fornecedor += (" - " + posicaoTCMSBC['Fornecedor 4']);
    // }
    // if (posicaoSESE && posicaoSESE['Fornecedor 1']) {
    //   fornecedor += (" - " + posicaoSESE['Fornecedor 1']);
    // }
    // if (posicaoSESE && posicaoSESE['Fornecedor 2']) {
    //   fornecedor += (" - " + posicaoSESE['Fornecedor 2']);
    // }
    // if (posicaoSESE && posicaoSESE['Fornecedor 3']) {
    //   fornecedor += (" - " + posicaoSESE['Fornecedor 3']);
    // }
    // if (posicaoSESE && posicaoSESE['Fornecedor 4']) {
    //   fornecedor += (" - " + posicaoSESE['Fornecedor 4']);
    // }

    return fornecedor;
  }

  teste() {
    console.log("teste imprimir");
  }

  async getPosicaoFromDynamoDB(tabela: string): Promise<any[]> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(
          tabela,
          this.urlConsultaCompactada,
          'All',
          this.filterColumn,
          this.referenceDate,
          this.numDays
        )).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            const plateMap = new Map();
            items.forEach(item => {
              const plate = item.Plate;
              if (!plateMap.has(plate)) {
                plateMap.set(plate, { ...item, checked: false });
              } else {
                const existingItem = plateMap.get(plate);
                plateMap.set(plate, {
                  ...existingItem,
                  ...item,
                  checked: false
                });
              }
            });
            return Array.from(plateMap.values())
              .filter(item =>
                item.ViagemCompleta != true &&
                item.ViagemCompleta != "true" &&
                item.ViagemCompleta != "True"
              );
          } else {
            console.error('Invalid items data:', items);
            return [];
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
          return [];
        }
      } else {
        console.error('Response is undefined or null');
        return [];
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }


  async getPosicaoMilkRastreioFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        // "tableName": "Itens_Jetta",
        // "searchConditions": [
        // //   { "column": "Finalizada", "word": true, "negate": true },
        // //   { "column": "Finalizada", "word": "true", "negate": true },
        // //   { "column": "Finalizada", "word": "True", "negate": true }
        // ]
        "tableName": this.query4,
        "searchConditions": [
          { "column": "Finalizada", "word": true, "negate": true },
          { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true },
          // { "column": "description", "word": "JSL", "negate": false },
          // { "column": "description", "word": "jsl", "negate": false },
          { "column": "FinalizadaManual", "word": true, "negate": true },
          // { "column": "ID", "word": "", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTripsFiltro, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      // const response: any = await new Promise(async (resolve, reject) => {
      //   (await this.dynamodbService.getItems(this.query4, this.urlConsulta, '')).subscribe(
      //     (res: any) => resolve(res),
      //     (error: any) => reject(error)
      //   );
      // });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.posicaoVeiculos = items
              .map(item => ({ ...item, checked: false }))
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida e item.Finalizada !== true       
            // console.log(items)   
            // console.log(this.posicaoVeiculos)   
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getLocais(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.queryFornecedores, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locais = items;
              // console.log(this.locais)
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getFornecedoresFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "Fornecedores_Karrara_Transport",
        "searchConditions": [
          //   { "column": "Finalizada", "word": true, "negate": true },
          //   { "column": "Finalizada", "word": "true", "negate": true },
          //   { "column": "Finalizada", "word": "True", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            // this.fornecedores = items
            this.fornecedores = items.map(item => ({
              latitude: parseFloat(item.latitude),
              longitude: parseFloat(item.longitude),
              popupContent: item.local
            }));
            // console.log(this.fornecedores)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compareAndMergePlatesJSL(): void {
    // console.log(this.posicaoSul);
    // console.log(this.posicaoVeiculos);
    if (this.posicaoJSL && this.posicaoVeiculos) {
      for (let i = 0; i < this.posicaoJSL.length; i++) {
        const plate = this.posicaoJSL[i].Plate;
        const matchingPlate = this.posicaoVeiculos.find(item => item.ID === plate);
        // console.log(item.ID)
        if (matchingPlate) {
          // console.log(matchingPlate.description)
          // console.log(plate)
          if (plate == "RTQ6E18") {
            //       console.log(matchingPlate)
            // console.log(this.posicaoJSL[i]);
          }
          // console.log(matchingPlate.ID)
          this.posicaoJSL[i].IdTrip = this.posicaoJSL[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoJSL[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              this.posicaoJSL[i][key] = matchingPlate[key];
            }
            // console.log(matchingPlate);
          });
        }
      }
    }
    // console.log(this.posicaoSul);
  }

  compareAndMergePlatesJSLItaqua(): void {
    // console.log(this.posicaoSul);
    // console.log(this.posicaoVeiculos);
    if (this.posicaoJSLItaqua && this.posicaoVeiculos) {
      for (let i = 0; i < this.posicaoJSLItaqua.length; i++) {
        const plate = this.posicaoJSLItaqua[i].Plate;
        const matchingPlate = this.posicaoVeiculos.find(item => item.ID === plate);
        // console.log(item.ID)
        if (matchingPlate) {
          // console.log(matchingPlate.description)
          // console.log(plate)
          if (plate == "RTQ6E18") {
            //       console.log(matchingPlate)
            // console.log(this.posicaoJSLItaqua[i]);
          }
          // console.log(matchingPlate.ID)
          this.posicaoJSLItaqua[i].IdTrip = this.posicaoJSLItaqua[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoJSLItaqua[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              this.posicaoJSLItaqua[i][key] = matchingPlate[key];
            }
            // console.log(matchingPlate);
          });
        }
      }
    }
    // console.log(this.posicaoSul);
  }

  compareAndMergePlatesTCM(): void {
    // console.log(this.posicaoSul);
    // console.log(this.posicaoVeiculos);
    if (this.posicaoTCM && this.posicaoVeiculos) {
      for (let i = 0; i < this.posicaoTCM.length; i++) {
        const plate = this.posicaoTCM[i].Plate;
        const matchingPlate = this.posicaoVeiculos.find(item => item.ID === plate);
        // console.log(item.ID)
        if (matchingPlate) {
          // console.log(matchingPlate.description)
          // console.log(plate)
          if (plate == "RTQ6E18") {
            //       console.log(matchingPlate)
            // console.log(this.posicaoTCM[i]);
          }
          // console.log(matchingPlate.ID)
          this.posicaoTCM[i].IdTrip = this.posicaoTCM[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoTCM[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              this.posicaoTCM[i][key] = matchingPlate[key];
            }
            // console.log(matchingPlate);
          });
        }
      }
    }
    // console.log(this.posicaoSul);
  }

  compareAndMergePlatesTCMSBC(): void {
    // console.log(this.posicaoSul);
    // console.log(this.posicaoVeiculos);
    if (this.posicaoTCMSBC && this.posicaoVeiculos) {
      for (let i = 0; i < this.posicaoTCMSBC.length; i++) {
        const plate = this.posicaoTCMSBC[i].Plate;
        const matchingPlate = this.posicaoVeiculos.find(item => item.ID === plate);
        // console.log(item.ID)
        if (matchingPlate) {
          // console.log(matchingPlate.description)
          // console.log(plate)
          if (plate == "RTQ6E18") {
            //       console.log(matchingPlate)
            // console.log(this.posicaoTCMSBC[i]);
          }
          // console.log(matchingPlate.ID)
          this.posicaoTCMSBC[i].IdTrip = this.posicaoTCMSBC[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoTCMSBC[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              this.posicaoTCMSBC[i][key] = matchingPlate[key];
            }
            // console.log(matchingPlate);
          });
        }
      }
    }
    // console.log(this.posicaoSul);
  }

  compareAndMergePlatesSESE(): void {
    // console.log(this.posicaoSul);
    // console.log(this.posicaoVeiculos);
    if (this.posicaoSESE && this.posicaoVeiculos) {
      for (let i = 0; i < this.posicaoSESE.length; i++) {
        const plate = this.posicaoSESE[i].Plate;
        const matchingPlate = this.posicaoVeiculos.find(item => item.ID === plate);
        // console.log(item.ID)
        if (matchingPlate) {
          // console.log(matchingPlate.description)
          // console.log(plate)
          if (plate == "RTQ6E18") {
            //       console.log(matchingPlate)
            // console.log(this.posicaoSESE[i]);
          }
          // console.log(matchingPlate.ID)
          this.posicaoSESE[i].IdTrip = this.posicaoSESE[i].ID;
          // Copiar as demais chaves de matchingPlate para this.posicaoSESE[i]
          Object.keys(matchingPlate).forEach(key => {
            if (key !== 'Plate') {
              this.posicaoSESE[i][key] = matchingPlate[key];
            }
            // console.log(matchingPlate);
          });
        }
      }
    }
    // console.log(this.posicaoSul);
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  private createMarkerElement(imageUrl: string, imageUrl2: string): HTMLDivElement {
    const element = document.createElement('div');
    element.className = 'small-marker';
    // Aplicar estilo para empilhar as imagens verticalmente
    element.style.display = 'flex';
    element.style.flexDirection = 'column';
    element.style.alignItems = 'center'; // Centralizar as imagens
    const image = document.createElement('img');
    const image2 = document.createElement('img');
    image.src = imageUrl;
    image2.src = imageUrl2;
    element.appendChild(image2);
    element.appendChild(image);
    return element;
  }

  async localizaCarroEdit(placa: string): Promise<void> {
    // console.log("edit");
    // console.log(placa);
    // Verificar em this.posicao
    this.item = await this.posicaoJSL.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    this.item = await this.posicaoJSLItaqua.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Verificar em this.containers
    this.item = await this.posicaoTCM.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      this.item.nextPoint = this.item.destino;
      console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Verificar em this.posicaoArg
    this.item = await this.posicaoTCMSBC.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }

    this.item = await this.posicaoSESE.find(item => item.Plate === placa);
    if (this.item) {
      this.edit2 = true;
      console.log(this.item)
      await this.calculaDistanciaAteNextPoint(this.item)
      this.editDialog(this.item)
      return;
    }
    // Se nenhum item for encontrado, exibir uma mensagem ou realizar outra ação
    console.log("Item não encontrado");
  }

  editDialog(item: any): void {
    // console.log(item)
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = item.Transportadora ? item.Transportadora.toLowerCase() : item.transportadora ? item.transportadora.toLowerCase() : '';
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado))) {
      this.item = { ...item };
      if (item.description && item.description?.includes("JSL")) {
        this.item.transportadora = "JSL"
      }
      else if (item.description && item.description?.includes("TCM")) {
        this.item.transportadora = "TCM"
      }
      else if (item.description && item.description?.includes("ARG")) {
        this.item.transportadora = "JSL"
      }
      else if (item.transportador && item.transportador?.includes("LOTS")) {
        this.item.transportadora = "LOTS"
      }
      else if (item.transportador && item.transportador?.includes("SUZAN")) {
        this.item.transportadora = "SUZAN"
      }
      else if (item.Transportadora) {
        this.item.transportadora = item.Transportadora
      }
      else {
        this.item.transportadora = "Sem registro"
      }
      for (let i = 1; i <= 4; i++) {
        this.item["Fornecedor" + i] = item["Fornecedor " + i];
        const dataHoraString = item["Janela " + i];
        if (dataHoraString) { // Verifica se a chave existe no objeto
          const dataString = dataHoraString.slice(0, 10); // "2024-04-23"
          const horaString = dataHoraString.slice(11, 16); // "00:00"
          this.item["dataJanela" + i] = dataString;
          this.item["horaJanela" + i] = horaString;
        }
      }
      for (let i = 1; i <= 4; i++) {
        this.item["Destino" + i] = item["Destino " + i];
        const dataHoraString = item["JanelaDestino " + i];
        if (dataHoraString) { // Verifica se a chave existe no objeto
          const dataString = dataHoraString.slice(0, 10); // "2024-04-23"
          const horaString = dataHoraString.slice(11, 16); // "00:00"
          this.item["dataJanelaDestino" + i] = dataString;
          this.item["horaJanelaDestino" + i] = horaString;
        }
      }
      this.dialogOpen = true;
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  cancel(): void {
    this.edit2 = false;
    this.dialogOpen = false;
  }

  async salvar() {
    for (let i = 1; i <= 4; i++) {
      if (this.item["dataJanela" + i]) {
        this.item["Janela " + i] = `${this.item["dataJanela" + i]}T${this.item["horaJanela" + i]}:00.000Z`;
      }
    }
    for (let i = 1; i <= 4; i++) {
      if (this.item["dataJanelaDestino" + i]) {
        this.item["JanelaDestino " + i] = `${this.item["dataJanelaDestino" + i]}T${this.item["horaJanelaDestino" + i]}:00.000Z`;
      }
    }
    this.isLoading = true;
    this.item = {
      ...this.item,
      "ID": this.item.IdTrip,
      "lastUpdate": new Date(),
    }
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.item.tableName, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.update();
      this.edit2 = false;
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  encontrarNextPoint(item: any): Promise<string> {
    // debugger
    let nextPoint;
    if (item['Fornecedor 1'] && (!item['Passo Fornecedor1'] || (item['Passo Fornecedor1'] != 1 && item['Passo Fornecedor1'] != 2))) {
      // console.log('Fornecedor 1')
      nextPoint = item['Fornecedor 1'];
    } else if (item['Fornecedor 2'] && (!item['Passo Fornecedor2'] || (item['Passo Fornecedor2'] != 1 && item['Passo Fornecedor2'] != 2))) {
      nextPoint = item['Fornecedor 2'];
      // console.log('Fornecedor 2')
    } else if (item['Fornecedor 3'] && (!item['Passo Fornecedor3'] || (item['Passo Fornecedor3'] != 1 && item['Passo Fornecedor3'] != 2))) {
      nextPoint = item['Fornecedor 3'];
      // console.log('Fornecedor 3')
    } else if (item['Fornecedor 4'] && (!item['Passo Fornecedor4'] || (item['Passo Fornecedor4'] != 1 && item['Passo Fornecedor4'] != 2))) {
      nextPoint = item['Fornecedor 4'];
      // console.log('Fornecedor 4')
    } else if (item['Destino 1'] && (!item['Passo Destino1'] || (item['Passo Destino1'] != 1 && item['Passo Destino1'] != 2))) {
      nextPoint = item['Destino 1'];
      // console.log('Destino 1')
    } else if (item['Destino 2'] && (!item['Passo Destino2'] || (item['Passo Destino2'] != 1 && item['Passo Destino2'] != 2))) {
      nextPoint = item['Destino 2'];
      // console.log('Destino 2')
    } else if (item['Destino 3'] && (!item['Passo Destino3'] || (item['Passo Destino3'] != 1 && item['Passo Destino3'] != 2))) {
      nextPoint = item['Destino 1'];
      // console.log('Destino 3')
    } else if (item['Destino 4'] && (!item['Passo Destino4'] || (item['Passo Destino4'] != 1 && item['Passo Destino4'] != 2))) {
      nextPoint = item['Destino 4'];
      // console.log('Destino 4')
    } else {
      if (!item.Finalizada || !item.FinalizadaManual || !item.ViagemCompleta) {
        if (item['Destino 4']) {
          nextPoint = item['Destino 4'];
        } else if (item['Destino 3']) {
          nextPoint = item['Destino 3'];
        } else if (item['Destino 2']) {
          nextPoint = item['Destino 2'];
          nextPoint = "sem next Point"
        } else if (item['Destino 1']) {
          nextPoint = item['Destino 1'];
          // console.log(nextPoint);
        }
      }
    }
    return nextPoint;
  }

  async calculaDistanciaAteNextPoint(item: any) {
    try {
      // console.log(item)
      // console.log(item.nextPoint)
      if (item.nextPoint != "sem next Point") {
        // console.log(item.nextPoint)
        // console.log(item)
        const destinoLocation = await this.findLocationByName(item.nextPointCompleto.local, this.locais);
        console.log(destinoLocation)
        const destinoLocationNumber = this.convertItem(destinoLocation);
        const truckPosition = this.convertItemViagem(item);
        // console.log(truckPosition)
        const distance1 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [truckPosition.longitude, truckPosition.latitude]);
        // console.log(item)
        item.prevChegada = this.adicionarSegundosAoTimestamp(distance1[1]);
        item.distanceNextPoint = distance1[0];
      } else {
        item.distanceNextPoint = 0;
      }
    } catch (error) {
      console.error('Erro ao calcular a distância:', error);
    }
  }

  async findLocationByName(name: string, locations: any[]): Promise<Location> {
    // debugger
    if (name == "LCB") {
      name = "LCB DEMARCHI"
    }
    console.log(locations)
    console.log(name)
    return await locations.find((location: { local: string; }) => location.local === name);
  }

  async findLocationNextPoint(item: any, locations: any[]) {
    // debugger
    if (item.nextPoint == "LCB") {
      item.nextPoint = "LCB DEMARCHI"
    }
    // console.log(locations)
    item.nextPointCompleto = locations.find((location: { local: string; }) => location.local === item.nextPoint);
    // console.log(item.nextPointCompleto)
  }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number]> {
    try {
      // console.log(startLocation)
      // console.log(endLocation)
      const response: any = await (await this.dynamodbService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return [0, 0];
        }
      } else {
        console.error('Invalid response:', response);
        return [0, 0];
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return [0, 0];
    }
  }

  convertItem(item: any): any {
    // console.log(item)
    return {
      ID: item.ID,
      latitude: parseFloat(item.latitude),  // Convertendo latitude para número
      local: item.local,
      longitude: parseFloat(item.longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  convertItemViagem(item: any): any {
    // console.log(item)
    return {
      ID: item.ID,
      latitude: parseFloat(item.Latitude),  // Convertendo latitude para número
      local: item.nextPoint,
      longitude: parseFloat(item.Longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  adicionarSegundosAoTimestamp(segundos: number): Date {
    const timestampAtual = Date.now();
    const novoTimestamp = timestampAtual + (segundos * 1000);
    return new Date(novoTimestamp);
  }


}
